<template>
    <div>
        起订量
        <el-popover
            placement="bottom"
            trigger="click"
            v-model="visible">
            <div style="margin-bottom: 8px">
                <el-input v-model="quantityBatchValue" @input="value => quantityBatchValue = value.replace(/[^\d]/g, '')"></el-input>
            </div>
            <div class="f-b">
                <el-button>取消</el-button>
                <el-button @click="orderQuantityBatch" type="primary">确定</el-button>
            </div>
            <i class="el-icon-edit pointer" slot="reference" style="color:#99c41c"></i>
        </el-popover>
    </div>
</template>

<script>
export default {
    data() {
        return {
            quantityBatchValue: undefined,
            visible: false
        }
    },
    methods: {
        orderQuantityBatch() {
            this.$emit('submit', this.quantityBatchValue)
            this.visible = false
            this.quantityBatchValue = undefined
        }
    },
}
</script>